/** @format */
import MvnoBlockApiRequest from '../../../interfaces/platform/MvnoBlockApiRequest';

export default class ApiQueryProductPlk {
    private json: any | null;

    isQueryProductPlk = (item: MvnoBlockApiRequest): boolean => {
        if (!item.requestRaw) {
            return false;
        }
        this.json = JSON.parse(item.requestRaw);
        return item.apiCommand === 'queryProductPlk';
    };

    getRequest = (name: string): string | null => {
        switch (name) {
            case 'PlusgetSubscriptionResponse':
            case 'PlusgetAccountForSubscriptionResponse':
                return this.getReq('Polkomtel\\Entity\\Get\\' + name);
            default:
                return '';
        }
    };

    getResponse = (name: string): string | null => {
        switch (name) {
            case 'PlusgetSubscriptionResponse':
            case 'PlusgetAccountForSubscriptionResponse':
                return this.getRes('Polkomtel\\Entity\\Get\\' + name);
            default:
                return '';
        }
    };

    getReq = (fullName: string): string | null => {
        let x = this.json[fullName];
        if (!x && !x.XML_REQUEST) {
            return null;
        }
        return x.XML_REQUEST;
    };

    getRes = (fullName: string): string | null => {
        let x = this.json[fullName];
        if (!x && !x.XML_RESPONSE) {
            return null;
        }
        return x.XML_RESPONSE;
    };
}
